import React, { useState } from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale } from '@components/frame';

import { font as initialFont } from '@styles/fonts';

import TouchableElement from '@components/common/touchableElement';
import BackButton from '@components/common/backButton';
import { modalBg } from '@v2/pages/common/constants/base.constants';

export default ({
  C,
  rightAction,
  rightActionText,
  rightActionLock,
  onBackPress,
  rightActionDisable,
  title = 'Production Information',
  text,
  mainBg,
  scale = initialScale,
  font = initialFont,
}) => {
  const [leftWidth, setLeftWidth] = useState(0);
  const [rightWidth, setRightWidth] = useState(0);
  const [isCalculated, setIsCalculated] = useState(false);

  // Calculate the maximum width to use as padding on both sides
  const maxSideWidth = Math.max(leftWidth, rightWidth);

  // Check if calculations are done
  React.useEffect(() => {
    if (leftWidth > 0 && (!rightAction || rightWidth > 0)) {
      setIsCalculated(true);
    }
  }, [leftWidth, rightWidth, rightAction]);
  return (
    <View
      style={{
        height: scale(44),
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C(mainBg ?? modalBg),
        marginTop: scale(12),
        marginBottom: scale(6),
      }}
    >
      <View
        style={{ position: 'absolute', left: scale(3), zIndex: 10000 }}
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          setLeftWidth(width + scale(3)); // Include left offset
        }}
      >
        <BackButton
          scale={scale}
          font={font}
          onPress={() => {
            if (onBackPress) {
              onBackPress();
            }
          }}
        />
      </View>
      {rightAction && (
        <View
          style={{ position: 'absolute', right: scale(18), zIndex: 10000 }}
          onLayout={(event) => {
            const { width } = event.nativeEvent.layout;
            setRightWidth(width + scale(18)); // Include right offset
          }}
        >
          <TouchableElement
            onPress={() => {
              rightAction();
            }}
          >
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle]}>
                {rightActionLock ? (
                  <ActivityIndicator color={C('Label/Light/Tertiary')} />
                ) : (
                  <Text style={[font.Headline, { color: C(pressHoverColor(rightActionDisable ? 'Label/Light/Quinary' : 'System/Light/Blue')) }]}>
                    {i18n.t(rightActionText)}
                  </Text>
                )}
              </View>
            )}
          </TouchableElement>
        </View>
      )}
      <View style={{
        position: 'absolute',
        left: 0,
        right: 0,
        alignItems: 'center',
        paddingHorizontal: maxSideWidth + scale(10), // Dynamic padding based on larger side element
        opacity: isCalculated ? 1 : 0 // Hide until calculations are done
      }}>
        <Text numberOfLines={1} style={[font.Headline, { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
          {i18n.t(title)}
        </Text>
        {text && (
          <Text numberOfLines={2} style={[font.Body, { color: C('Label/Light/Primary'), marginTop: scale(8), textAlign: 'center' }]}>
            {i18n.t(text)}
          </Text>
        )}
      </View>
    </View>
  );
};
